// A restrained, CSS-driven infrastructure visual: a glowing core with
// orbiting service nodes and connecting data-flow lines. No JS animation
// libraries needed — animation-duration is disabled site-wide under
// prefers-reduced-motion via globals.css.

const nodes = [
  { label: "VPS", angle: 0 },
  { label: "Dedicated", angle: 72 },
  { label: "Cloud", angle: 144 },
  { label: "Email", angle: 216 },
  { label: "Security", angle: 288 },
];

export function InfrastructureVisual() {
  return (
    <div className="relative mx-auto flex h-[380px] w-[380px] items-center justify-center sm:h-[440px] sm:w-[440px]">
      {/* orbit rings */}
      <div className="absolute inset-0 animate-orbit-slow rounded-full border border-border" />
      <div className="absolute inset-10 animate-orbit-slower rounded-full border border-border" />

      {/* core */}
      <div className="glass-panel relative z-10 flex h-28 w-28 flex-col items-center justify-center rounded-full shadow-[0_0_60px_-10px_rgba(37,199,255,0.5)]">
        <span className="h-2 w-2 animate-pulse-dot rounded-full bg-status-success" />
        <span className="mt-2 font-display text-[11px] font-medium text-text-primary">
          The Planet
        </span>
        <span className="text-[9px] text-text-muted">Core</span>
      </div>

      {/* orbiting nodes */}
      {nodes.map((node) => {
        const radius = 175;
        const rad = (node.angle * Math.PI) / 180;
        const x = Math.cos(rad) * radius;
        const y = Math.sin(rad) * radius;
        return (
          <div
            key={node.label}
            className="glass-panel absolute flex items-center gap-1.5 rounded-full px-3 py-1.5"
            style={{ transform: `translate(${x}px, ${y}px)` }}
          >
            <span className="h-1.5 w-1.5 rounded-full bg-cyan" />
            <span className="text-[10px] font-medium text-text-secondary">{node.label}</span>
          </div>
        );
      })}

      <svg className="absolute inset-0 h-full w-full" viewBox="0 0 440 440" aria-hidden="true">
        {nodes.map((node) => {
          const radius = 175;
          const rad = (node.angle * Math.PI) / 180;
          const x = 220 + Math.cos(rad) * radius;
          const y = 220 + Math.sin(rad) * radius;
          return (
            <line
              key={node.label}
              x1="220"
              y1="220"
              x2={x}
              y2={y}
              stroke="rgba(37,199,255,0.18)"
              strokeWidth="1"
              strokeDasharray="3 5"
            />
          );
        })}
      </svg>
    </div>
  );
}
